/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Box, Button, Chip, Dialog, DialogContent, DialogTitle, Grid, Icon, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { Close } from "@mui/icons-material";
import './styles.scss';
import { Formater, LocalStorage, StringUtil, TypeRecords } from "src/framework/commons";
import theme from "src/theme/light";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { TCarrinho, TCarrinhoAvulso } from "../Carrinho/types";
import { estadoId$, resolveProtocolUrl, resolveUploadUrl } from "src/store/global.store";
import { ComponenteType } from "src/types";
import { useObservable } from "src/framework/store/storeUtil";
import { ATRIBUTOS_MAP, CABO_ID, EXIBIR_ATRIBUTOS, INVERSORES, INVERSORES_OFFGRID, INVERSORES_ONDA, MODULO_ID, VALOR_MULTIPLO_CABO } from "src/pages/Home/constants";
import FileSaver from "file-saver";
import { ADMIN_MAX_VALUE, MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { permissoes$ } from "src/framework/store";
import { CarrinhoStore } from "../Carrinho/store";


interface IDetahlhesAvulso {
    open: boolean,
    adicaoDesabilitada: boolean;
    carrinho: TCarrinho | null
    componente: ComponenteType;
    onClose: () => void;
    onAdd: (item: TCarrinhoAvulso) => void;
}

const DetalhesAvulso: FC<IDetahlhesAvulso> = ({ carrinho, componente, open, onClose, onAdd, adicaoDesabilitada }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const uploadUrl = resolveUploadUrl(LocalStorage.get("solar.uploads", true) || null) || ""

    const estadoId = useObservable(estadoId$) || "";

    const [quantidade, setQuantidade] = useState<number>(1);
    const [quantidadeMax, setQuantidadeMax] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);

    const isAdmin = useMemo(() => {
        return PermissionUtil.isAdministrador(permissoes$.value);
    }, []);

    const resolvePreco = (): number => {
        let valor = componente.valor;
        if (!valor) {
            const precos = componente?.precos || [];
            const precoUf = precos?.find(i => i.estado_id === estadoId);
            valor = precoUf?.valor || 0;
        }
        return valor * quantidade
    }

    useEffect(()=>{
        if (componente) {
            setQuantidade((componente?.categoria_componentes_id === CABO_ID ? VALOR_MULTIPLO_CABO : 1))
            setQuantidadeMax(componente?.quantidade_maxima_venda_avulso || (componente?.categoria_componentes_id === CABO_ID ? VALOR_MULTIPLO_CABO : quantidadeMax))
        }
    },[open])
    
    const renderAtributos = useCallback((categoriaId: number) => {
        if (!EXIBIR_ATRIBUTOS.includes(categoriaId)) return null;

        const quantidadeMppt = componente?.mppt?.length || 0;

        const atributosConfig = INVERSORES_ONDA?.includes(categoriaId)
            ? ATRIBUTOS_MAP["INVERSORES_ONDA"]
            : ATRIBUTOS_MAP[categoriaId];

        if (!atributosConfig) return null;

        const atributosMap = new Map(
            componente?.atributos?.map(attr => [attr.atributo, attr]) || []
        );

        const lista = Object.entries(atributosConfig)
            .map(([atributoKey, config]) => {
                const attr = atributosMap.get(atributoKey);
                if (!attr && atributoKey !== 'QUANTIDADE_MPPT') return null;

                let valor = config.format
                    ? config.format(attr?.valor)
                    : Number(attr?.valor);

                // Caso fora dos Atributos
                if (atributoKey === 'QUANTIDADE_MPPT' && quantidadeMppt) {
                    valor = quantidadeMppt;
                } else if (atributoKey === 'QUANTIDADE_MPPT' && !quantidadeMppt) {
                    return null;
                }

                return (
                    <li key={atributoKey}>
                        <strong>{config.label}</strong>: {valor || ""}
                    </li>
                );
            })
            .filter(Boolean);
        
        return lista;
    }, [componente?.atributos, componente?.mppt]);

    const downloadDocumento = (url: string, tipo: string, nomeArquivo: string): void => {
        if (url !== "") {
            let _nomeArquivo = nomeArquivo;
            _nomeArquivo = StringUtil.clear(_nomeArquivo);
            _nomeArquivo = _nomeArquivo.replace(/[^a-zA-Z0-9-\u00C0-\u00FF\s]/g, "");
            const name: string[] = url.split(".");
            const extension: string | undefined = name.pop()?.replace(/\?r=\d{1,}/, "");
            if (extension) {
                FileSaver.saveAs(url, `${tipo}-${_nomeArquivo}.${extension}`?.replace(`${tipo}-${tipo}`, `${tipo}-`));
            }
        }
    };

    const checkError = useCallback((categoriaId: number, qtd: number): boolean => {
        if (categoriaId !== CABO_ID) {
            return false;
        }
        if (qtd === 0) {
            return false;
        }
        if (qtd % 25 === 0) {
            return false;
        }
        return true
    }, []);

    const disabled = useMemo(() => {
        return checkError(componente?.categoria_componentes_id, quantidade)
    }, [componente, quantidade]);

    return <Dialog className='DetalhesAvulso' open={open} maxWidth="lg">
        <DialogTitle>
            <Box style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row" }} >
                <Button
                    variant="text"
                    color="primary"
                    startIcon={<Close />}
                    onClick={() => { onClose() }}
                >
                    Fechar
                </Button>
            </Box>

        </DialogTitle>
        <DialogContent className="hide-scrollbar">
            <Box className="tags">
                {componente?.grupo_categoria && <Chip
                    className="tags"
                    color="secondary"
                    label={componente?.grupo_categoria?.toLocaleUpperCase()}
                /> }                   
                {componente?.fabricante && <Chip
                    className="tags"
                    color="secondary"
                    label={componente?.fabricante?.toLocaleUpperCase()}
                /> }
            </Box>
            <Box style={{ marginTop: "10px" }}>
                <Typography variant="h6">{componente.nome}</Typography>
            </Box>
            <Box>
                <Grid container style={{ marginTop: "10px" }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Grid size={{ xs: 12 }}>
                            <img
                                width={isMobile ? "100%" : 300}
                                src={`//${uploadUrl}${componente.imagem}`}
                                title="Imagem ilustrativa do produto"
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            {componente?.datasheet && (
                                <Button
                                    fullWidth={isMobile}
                                    variant={isMobile ? "outlined" : "text"}
                                    size={isMobile ? "medium" : "small"}
                                    onClick={() => {
                                        downloadDocumento(resolveProtocolUrl(`//${uploadUrl}${componente?.datasheet || ""}`), "datasheet", `datasheet-${componente?.nome?.toLocaleLowerCase()}`);
                                    }}
                                    color={'primary'}
                                    sx={{ marginTop: 2 }}
                                >
                                    <Box display={"flex"}>
                                        <Icon style={{ marginRight: "2px" }} color={"primary"}>download</Icon>
                                        <strong>DataSheet</strong>
                                    </Box>
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <ul>
                            <li key={`tempo-garantia`}><strong>Tempo de garantia</strong>: {componente?.tempo_garantia ? `${componente.tempo_garantia} ${componente.tempo_garantia_unidade}` : ""}</li>
                            <li key={`marca`}><strong>Marca</strong>: {componente?.fabricante ? componente.fabricante : ""}</li>
                            {!INVERSORES?.includes(componente.categoria_componentes_id) && componente.categoria_componentes_id !== MODULO_ID && <li key={`altura`}><strong>Altura (m)</strong>: {componente?.altura ? (componente.altura/1000) : ""}</li>}
                            {!INVERSORES?.includes(componente.categoria_componentes_id) && componente.categoria_componentes_id !== MODULO_ID && <li key={`comprimento`}><strong>Comprimento (m)</strong>: {componente?.comprimento/1000 ? (componente.comprimento/1000) : ""}</li>}
                            {!INVERSORES?.includes(componente.categoria_componentes_id) && componente.categoria_componentes_id !== MODULO_ID && <li key={`largura`}><strong>Largura (m)</strong>: {componente?.largura/1000 ? (componente.largura/1000) : ""}</li>}
                            {!INVERSORES_OFFGRID?.includes(componente.categoria_componentes_id) && componente.categoria_componentes_id !== CABO_ID && <li key={`peso`}><strong>Peso (Kg)</strong>: {componente?.peso ? componente.peso : ""}</li>}
                            {renderAtributos(componente.categoria_componentes_id)}
                        </ul>
                    </Grid>
                </Grid>
            </Box>
            <Box>
                <Grid container spacing={2} style={{ display: "flex", alignItems: "center" }}>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Box sx={{
                                width: "100%",
                                display: isMobile ? "block" : "flex",
                                justifyContent: "flex-start",
                                textAlign: "left",
                                position: "relative",
                                left: isMobile ? "0px" : "-25px"
                            }}>
                            <Grid size={12} flexDirection="column">
                                <InputQuantidade 
                                    avulso
                                    value={quantidade}
                                    hasError={checkError(componente?.categoria_componentes_id || 0, quantidade)}
                                    multiple={componente?.categoria_componentes_id === CABO_ID ? VALOR_MULTIPLO_CABO : 1}
                                    disableMenos={quantidade <= 1}
                                    maxValue={!isAdmin ? quantidadeMax : ADMIN_MAX_VALUE}
                                    minValue={componente?.categoria_componentes_id === CABO_ID ? VALOR_MULTIPLO_CABO : 1}
                                    onChange={(_quantidade: number) => {
                                        setQuantidade(_quantidade || 1)
                                    }}
                                />
                                {componente?.categoria_componentes_id === CABO_ID && checkError(componente?.categoria_componentes_id, quantidade) && (
                                    <span style={{ color: "#b91322", fontSize: "12px", position: "relative", left: "25px" }}>
                                        {MENSAGEM_QUANTIDADE_CABOS_INVALIDA}
                                    </span>
                                )}
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography variant="h5" component="p" style={{ color: theme.palette.warning.main, fontWeight: 'bold' }}>{Formater.toString(resolvePreco(), TypeRecords.CURRENCY)}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Tooltip title={quantidade > 0 ? "" : "Para prosseguir, selecione pelo menos um item."}>
                            <div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    disabled={adicaoDesabilitada || disabled || quantidade < 1 || loading}
                                    onClick={async () => {
                                        setLoading(true);
                                        if (componente) {
                                            const item: TCarrinhoAvulso = {
                                                componente_id: Number(componente.id),
                                                quantidade: Number(quantidade),
                                                valor: componente?.valor,
                                                componente,
                                            };

                                            const carrinho: TCarrinho | null = CarrinhoStore.getCarrinho();
                                            const find: TCarrinhoAvulso | undefined = carrinho?.avulsos?.find(i => (i?.componente?.id || i?.componente_id) === Number(componente.id));

                                            const quantidadeAtual = Number(find?.quantidade || 0);
                                            item.quantidade = quantidadeAtual + (Number(quantidade) || 1);
                                            if (CarrinhoStore.validaQuantidadeMaximaAvulso(item, isAdmin)) {
                                                item.quantidade = Number(quantidade);
                                                if (onAdd) { 
                                                    await onAdd(item);
                                                }
                                            } else {
                                                item.quantidade = quantidadeAtual;
                                            }
                                        }
                                        setTimeout(() => { setLoading(false) }, 700);
                                    }}
                                >Adicionar</Button>
                            </div>
                        </Tooltip>
                    </Grid>
                    
                </Grid>
            </Box>
        </DialogContent>

    </Dialog>
}

export { DetalhesAvulso }